import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  CircularProgress,
  TextField,
  DialogActions,
  Button
} from '@mui/material';
import { useSelector } from 'react-redux';
import { selectCurrentagency } from '../redux/features/authSlice';

const ExcelDialogTable = ({ open, onClose, excelData, loading, onSave }) => {
    const [updatedData, setUpdatedData] = useState([]);
    const currentAgency = useSelector(selectCurrentagency);

    useEffect(() => {
      if (excelData) {
        setUpdatedData(excelData);
      }
    }, [excelData]);
  
    const handleInputChange = (index, field, value) => {
      const newData = [...updatedData];
      newData[index][field] = value; 
      setUpdatedData(newData);
    };

    const handleSave = () => {
      const formattedLeads = updatedData.map((record) => ({
        sourceid: 9,
        status: 0,
        leadtype: record['Lead Type'],
        firstname: record['First Name'],
        lastname: record['Last Name'],
        userphone: record['Contact No'],
        companyName: record['Company Name'],
        propertyrefnum: record['Property Ref Num'],
        location: record.Location,
        designation: record.Designation,
        whatsappNo: record['Whatsapp No'],
        additionalNo: record['Additional No'],
        membershipId: record['Membership Id'],
        societyName: record['Society Name'],
        fileNo: record['File No'],
        plotNo: record['Plot No'],
        plotSize: record['Plot Size'],
        type: record.Type,
        block: record.Block,
        budget: record.Budget,
        useremail: record.Email,
        leadTime: new Date().toISOString(),
        agencyid: currentAgency.agencyid,
      }));
  
      onSave(formattedLeads);
    };
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Excel Leads Data
        <Button
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          Close
        </Button>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Grid container justifyContent="center" alignItems="center">
            <CircularProgress />
          </Grid>
        ) : (
          <div style={{ overflowX: 'auto', maxHeight: '400px' }}>
            <Grid container spacing={1} alignItems="center">
              {updatedData.map((record, index) => (
                <Grid item xs={12} key={index} mt={2}>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '30px repeat(18, 200px)',
                      alignItems: 'center',
                      gap: 4
                    }}
                  >
                    <div>{index + 1}</div>
                    <TextField
                      label="First Name"
                      value={record["First Name"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "First Name", e.target.value)}
                    />
                    <TextField
                      label="Last Name"
                      value={record["Last Name"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Last Name", e.target.value)}
                    />
                    <TextField
                      label="Society Name"
                      value={record["Society Name"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Society Name", e.target.value)}
                    />
                    <TextField
                      label="File No"
                      value={record["File No"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "File No", e.target.value)}
                    />
                    <TextField
                      label="Block"
                      value={record["Block"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Block", e.target.value)}
                    />
                    <TextField
                      label="Plot No"
                      value={record["Plot No"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Plot No", e.target.value)}
                    />
                    <TextField
                      label="Plot Size"
                      value={record["Plot Size"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Plot Size", e.target.value)}
                    />
                    <TextField
                      label="Membership Id"
                      value={record["Membership Id"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Membership Id", e.target.value)}
                    />
            
                    <TextField
                      label="Email"
                      value={record["Email"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Email", e.target.value)}
                    />
                    <TextField
                      label="Type"
                      value={record["Type"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Type", e.target.value)}
                    />
                    <TextField
                      label="Contact No"
                      value={record["Contact No"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Contact No", e.target.value)}
                    />
                    <TextField
                      label="Whatsapp No"
                      value={record["Whatsapp No"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Whatsapp No", e.target.value)}
                    />
                    <TextField
                      label="Additional No"
                      value={record["Additional No"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Additional No", e.target.value)}
                    />
                    <TextField
                      label="Property Ref Num"
                      value={record["Property Ref Num"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Property Ref Num", e.target.value)}
                    />
                    <TextField
                      label="Company Name"
                      value={record["Company Name"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Company Name", e.target.value)}
                    />
                    <TextField
                      label="Location"
                      value={record["Location"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Location", e.target.value)}
                    />
                    <TextField
                      label="Designation"
                      value={record["Designation"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Designation", e.target.value)}
                    />
                    <TextField
                      label="Budget"
                      value={record["Budget"] || ""}
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleInputChange(index, "Budget", e.target.value)}
                    />
                    
                  </div>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExcelDialogTable;
